import "../../styles/visualization/folderMeta.css";

const FolderMeta = ({ title, description }) => {
  return (
    <section className="folder-meta">
      <h1 className="folder-meta-title" title={title}>
        {title}
      </h1>

      {description && (
        <p className="folder-meta-description" title={description}>
          {description}
        </p>
      )}
    </section>
  );
};

export default FolderMeta;
